import React, { useEffect, useRef, useState } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import AboutV5 from './section-components/about-v5';
import ServiceV1 from './section-components/service-v1';
import BlogSlider from './blog-components/blog-slider-v1';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import axios, { API_URL } from "../lib/axios";
import { Mail, Star, Phone, Bold } from 'react-feather';
import html2canvas from 'html2canvas';
import QRCode from 'react-qr-code';
import { saveAs } from 'file-saver';

const Kartvizit = () => {
    const { id } = useParams();
    const [card, setCard] = useState({});
    const kartvizitRef = useRef(null);

    useEffect(() => {
        if (id) {
          axios(`/qrcard/frontend?id=${id}`)
            .then((data) => {
              if (data.data.success !== false) {
                setCard(data.data.qrcard);
              }
            })
            .catch((error) => {
              console.log("Hata:", error);
            });
        }
      }, [id]);


      const handleDownload = () => {
        html2canvas(kartvizitRef.current, {
          allowTaint: true,
          useCORS: true,
        }).then(canvas => {
          canvas.toBlob(
            blob => {
              saveAs(blob, `Kartvizit_${card.name}_${card.surname}.png`)
            },
            "image/png",
            1
          )
        })
      }


    return <div>
    <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
        <div class="flex-row">
        <div id='kartvizit' ref={kartvizitRef}>
        <BusinessCard qrcard={card} />
        </div>
        <div className='mt-3 text-center'>
        <button onClick={handleDownload}
        style={
            {
                background: "#4285F4",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
                cursor: "pointer",
            }
        }
        >İndir (PNG)</button>
        </div>
        </div>
    </div>
    </div>
}

function BusinessCard({
    qrcard,
    headerColor = "#fff",
    headerBg = "#4285F4",
    headerStyle = {},
    shadow = true,
    style = {},
    ...props
  }) {
    return (
      <div
        className="card-business"
        style={{
          background: "#fff",
          width: "100mm",
          height: "56mm",
          borderRadius: "5px",
          boxShadow: shadow !== false ? "#9E9E9E 0px 0px 10px" : "",
          ...style
        }}
        {...props}
      >
        <div
          style={{
            background: headerBg,
            height: "20mm",
            padding: 10,
            paddingTop: 15,
            paddingLeft: 20,
            position: "relative",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
            ...headerStyle
          }}
        >
          <img
            width={"60mm"}
            height={"60mm"}
            alt="avatar"
            style={{
              position: "absolute",
              right: 15,
              top: 5,
              borderRadius: "100%",
              float: "right",
              background: "#fff"
            }}
            src={API_URL + "/api/image?image=" + qrcard.photo + "&path=qrcard"}
          />
          <h1
            style={{
              fontSize: "17pt",
              margin: 0,
              marginRight: -50,
              color: headerColor
            }}
          >
            {qrcard.name + " " + qrcard.surname}
          </h1>
          {qrcard.title && (
            <p
              style={{
                margin: 0,
                fontSize: "11pt",
                marginRight: -50,
                color: "#ccc"
              }}
            >
              <span>{qrcard.title}</span>
            </p>
          )}
        </div>
        <div style={{ padding: 0, paddingLeft: 20, position: "relative" }}>
{/*        <QRCode
            size={80}
            style={{
            position: "absolute",
            right: 15,
            top: 5,
            float: "right",
          }}
            value={"https://safkar.com/kartvizit/" + qrcard.id}
            viewBox={`0 0 128 128`}
            />
            */}
            <img 
            src={"/assets/img/logo.png"}
            style={{
                position: "absolute",
                right: 15,
                top: 5,
                float: "right",
                width: 120,
                marginTop: 30
            }}
            />
            
          <ul
            style={{
              fontSize: "10pt",
              listStyle: "none",
              lineHeight: "15pt",
              margin: 0,
              padding: 0,
              paddingLeft: "20px", // Sol tarafa boşluk ekleyerek içeriği sağa yaslar
            }}
          >
            {qrcard.title && (
              <li style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
                <Star className='me-1' size={18} />
                {qrcard.title}
              </li>
            )}
            {qrcard.phone && (
              <li style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
                <Phone className='me-1' size={18} /> 
                {qrcard.phone}
              </li>
            )}
            {qrcard.mail && (
              <li style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}>
                <Mail className='me-1' size={18} />
                {qrcard.mail}
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }


export default Kartvizit

